import { BffApiUpdateItemError } from '../../../../types';

import {
  PaypalAttemptOrderID,
  CheckAndPayPaypalByOrderIdCacheKeys,
  CheckAndPayPaypalByOrderIdGqlStatus
} from '../../paypalAttemptsTypes';

import { CACHE_CHECK_AND_PAY_PAYPAL_BY_ORDER_ID_QUERY } from '../../queries/cacheCheckAndPayPaypalByOrderId.query';

import { useCacheUpdateQuery } from '../../../common/reactQuery/hooks/useCacheUpdateQuery';

interface CheckAndPayPaypalByOrderIdOptions {
  cacheKeys?: CheckAndPayPaypalByOrderIdCacheKeys;
}

interface CheckAndPayPaypalByOrderIdInput {
  orderId: PaypalAttemptOrderID;
}

interface CheckAndPayPaypalByOrderIdResponse {
  checkAndPayPaypalByOrderId: {
    status: CheckAndPayPaypalByOrderIdGqlStatus;
    content?: {
      details?: {
        issue?: string;
        description?: string;
      }[];
      message?: string;
      debug_id?: string;
      purchase_units?: unknown[];
    };
  };
}

type CheckAndPayPaypalByOrderIdError = BffApiUpdateItemError;

const action = 'checkAndPayPaypalByOrderId';

function useCacheCheckAndPayPaypalByOrderId({
  cacheKeys
}: CheckAndPayPaypalByOrderIdOptions = {}) {
  const {
    updateCacheQuery,
    updateCacheQueryErrorMessage,
    updateCacheQueryLoading
  } = useCacheUpdateQuery<
    CheckAndPayPaypalByOrderIdInput,
    CheckAndPayPaypalByOrderIdResponse,
    CheckAndPayPaypalByOrderIdError,
    void
  >({
    action,
    query: CACHE_CHECK_AND_PAY_PAYPAL_BY_ORDER_ID_QUERY,
    cacheKeys
  });

  return {
    checkAndPayPaypalByOrderIdLoading: updateCacheQueryLoading,
    checkAndPayPaypalByOrderIdErrorMessage: updateCacheQueryErrorMessage,
    checkAndPayPaypalByOrderId: updateCacheQuery
  };
}

export default useCacheCheckAndPayPaypalByOrderId;
